import { Site } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class SiteApi {
  async getSiteDetails(
    journeyType: number,
    instanceId: string,
    successCallback: (site: Site) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/site/site?instanceid=${instanceId}&journeytype=${journeyType}&pathname=${window.location.pathname}&browserLanguage=${navigator.language}`;

    await new ApiHelper().getDataAsync(
      dataUrl,
      successCallback,
      failureCallback,
      signal
    );
  }

  async validateCaptcha(
    token: string,
    successCallback: (hasAccess: boolean) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `api/Site/validate-captcha`;
    const data = { token: token };
    new ApiHelper().postDataAsync(
      dataUrl,
      data,
      successCallback,
      failureCallback,
      signal
    );
  }
}
